import { render } from "./InputCheckBox.vue?vue&type=template&id=236cde64"
import script from "./InputCheckBox.vue?vue&type=script&lang=js"
export * from "./InputCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__